/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, { useState, useEffect } from 'react';
import {Link} from "react-router-dom";
import { useParams } from "react-router-dom";
import axios from "axios";
import PageBox from "../../layouts/pageBox";
import PageHeader from "../../layouts/PageHeader";
import Loader from "../../elements/loader";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useTranslation} from "react-i18next";

const Makes = () => {

    let params = useParams();
    const [models, setModels] = useState([]);
    const [latestAds, setLatestAds] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [isLoading, setLoading] = useState(true);

    const axiosJWT = useAxiosJTW();
    const { t, i18n } = useTranslation();

    const [headerData, setHeaderData] = useState({
        title : '',
        description : '',
        logo: ''
    });

    const data = {
        title:  'Car models catalog',
        subtitle: 'Used car spare parts for all car makes and models!',
    };

    const getModelByMake = () => {
        axiosJWT.post('api/getmodelsbymake', { make: params.make }).then( (response) => {
            if(response.status === 200){

                setModels(response.data.models || []);
                setLatestAds(response.data.latest_ads.parts || []);
                setHeaderData({
                    title : response.data.title,
                    subtitle : null,
                    logo: response.data.logo,
                })
                setLoading(false);
                console.log(response);
            }
        } ).catch((error) => {
            console.log(error);
        });

    }

    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        getModelByMake();

        return () => {controller.abort();}
    }, [params]);

    const filterNames = ({ date }) => {
        return date.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1;
    };

    return (
        <PageBox data={data} latestAds={latestAds}>
            <div className='page-header'>
                <PageHeader data={headerData} onSearch={setSearchValue} value={searchValue}/>
            </div>
            <div className='page-body'>
                <div className='PartsByFirmModels'>
                    {isLoading ? (
                        <div style={{ paddingTop: '30px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>
                    ) : (
                        Object.keys(models).map((key, index) => {
                            return(
                                <div className={`PartsByFirmModels__item ${models[key].model_years.filter(filterNames).length > 0 ? "" : "PartsByFirmModels__item--hide"}`} key={index}>
                                    <div className='PartsByFirmModels__title'>{models[key].model_name}</div>
                                    <div className='PartsByFirmModels__body'>
                                        { models[key].model_years.filter(filterNames).map( (model, index2) => (
                                            <Link to={`/${i18n.language}/parts/${params.make}/${model.slug}/${model.url}`} className={`PartsByFirmModels__link ${parseInt(model.has_ads) === 0 ? "PartsByFirmModels__link--empty" : ""}`} key={index2}>{model.date}</Link>
                                        ) ) }
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </PageBox>
    );
};

export default Makes;
